import React, { Component } from 'react'

export class test extends Component {
    constructor(props) {
        super(props);
        this.state = {
            result: 0,
            num1: 0,
            num2: 0
        }
    }
    render() {
        const num = parseInt(this.state.num1, 10) + parseInt(this.state.num2, 10);
        return (
            <div>
                <h1>
                    <input onChange={(e) => this.setState({ num1: e.target.value })}></input>
                    <input onChange={(e) => this.setState({ num2: e.target.value })}></input>
                    <h2>{num}</h2>
                </h1>
            </div>
        )
    }
}

export default test
